<template>
  <div>
    <v-list-item
      v-if="exercise.type === 'superset'"
      :class="{ 'v-list-item--active': active }"
      :disabled="!exercise.exercises[0].exercise_start_at"
      @click="$emit('handle:click')"
    >
      <v-list-item-content>
        <v-list-item-title
          :class="{ 'font-weight-bold primary--text': active }"
        >
          {{ $t("training_builder.superset") }} x{{ exercise.params.NMSR }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ exercise.exercises.map(e => e.name ? e.name : $t('training_builder.pause')).join(' • ') }}
        </v-list-item-subtitle>
        <v-list-item-subtitle
          v-if="exercise.exercises[0].exercise_start_at"
          class="mt-1"
        >
          {{ $dayjs(exercise.exercises[0].exercise_start_at).format('HH:mm:ss') }} - {{ $dayjs(exercise.exercises[0].exercise_stop_at).format('HH:mm:ss') }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      v-else-if="exercise.type === 'exercise'"
      :class="{ 'v-list-item--active': active }"
      :disabled="!exercise.exercise_start_at"
      @click="$emit('handle:click')"
    >
      <v-list-item-content>
        <v-list-item-title
          :class="{ 'font-weight-bold primary--text': active }"
        >
          {{ exercise.name }}
        </v-list-item-title>
        <v-list-item-subtitle
          v-if="exercise.exercise_start_at"
          class="mt-1"
        >
          {{ $dayjs(exercise.exercise_start_at).format('HH:mm:ss') }} - {{ $dayjs(exercise.exercise_stop_at).format('HH:mm:ss') }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      v-else
      disabled
    >
      <v-list-item-content>
        <v-list-item-title
          :class="{ 'font-weight-bold primary--text': active }"
        >
          {{ $t("training_builder.pause") }}
        </v-list-item-title>
        <v-list-item-subtitle
          v-if="exercise.exercise_start_at"
          class="mt-1"
        >
          {{ $dayjs(exercise.exercise_start_at).format('HH:mm:ss') }} - {{ $dayjs(exercise.exercise_stop_at).format('HH:mm:ss') }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script >

export default {
  name: 'ExerciseListItem',
  props: {
    exercise: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>

<style>

</style>
